import type { ReactNode } from 'react';

export type Tone = 'green' | 'amber' | 'red' | 'blue' | 'grey';

interface StatusChipProps {
  tone: Tone;
  children: ReactNode;
  dot?: boolean;
}

export function StatusChip({ tone, children, dot = true }: StatusChipProps) {
  return (
    <span className={`chip chip--${tone}`}>
      {dot && <span className="chip__dot" aria-hidden />}
      {children}
    </span>
  );
}
